<template>
  <div
    class="select-list-item-parts"
    :class="{ 'select-list-item-parts--selected': isSelect }"
    @click="selectChange"
  >
    <div class="select-list-item-parts__card">
      <slot />
    </div>

    <img
      v-if="isSelect"
      class="select-list-item-parts__check"
      :src="require('@/assets/img/icon/icon_checkbox_24.svg')"
      alt="選択"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import PlayerDocument from '@/store/stores/collectionModule/documents/player/PlayerDocument'

/**
 * マイページ: 選択リスト アイテム パーツ
 */
export default defineComponent({
  name: 'SelectListItemParts',
  props: {
    /**
     * 表示データ
     */
    item: {
      type: Object as PropType<PlayerDocument>,
      required: true,
    },
    /**
     * 選択済みフラグ
     */
    selected: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    /**
     * 選択済みを監視
     */
    const isSelect = computed(() => props.selected)

    return {
      isSelect,
    }
  },
  methods: {
    /**
     * 選択を通知
     */
    selectChange(): void {
      this.$emit('select', this.item.id)
    },
  },
})
</script>

<style lang="scss" scoped>
.select-list-item-parts {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 58px;
  padding: 13px 16px;
  background: $white;

  &--selected {
    background: rgba($green-light, 0.5);
  }

  &__card {
    width: calc(100% - 24px);
    padding-right: 5px;
  }

  &__check {
    min-width: 24px;
  }
}
</style>
